import { useState } from "react";
import styles from "./UserAvatar.module.css";
import noImg from "../../../../../assets/img/no-images.jpg"; // Fallback image path
import PreviewImage from "../../../../../ExternalLib/PreviewImage/PreviewImage.jsx.jsx";
const UserAvatar = ({ src, alt }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <div className={styles.avatarContainer}>
      {/* 1. The Skeleton Loader (shows only while isLoaded is false) */}
      {!isLoaded && <div className={styles.skeletonAvatar}></div>}

      {/* 2. The Actual Image */}
      <img
        src={src}
        alt={alt}
        onLoad={() => setIsLoaded(true)} // Toggle state when finished
        onError={(e) => {
          e.target.src = noImg; // Fallback image on error
          setIsLoaded(true); // Stop showing skeleton even on error
        }}
      />
      {/* <PreviewImage
        imgwithUrl={src}
        className={`${styles.avatarImage} ${isLoaded ? styles.visible : styles.hidden}`}
      /> */}
    </div>
  );
};

export default UserAvatar;
